import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-satisfaction-survey-modal',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './satisfaction-survey-modal.component.html',
  styleUrl: './satisfaction-survey-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SatisfactionSurveyModalComponent {
  openFeedbackForm = output<void>();

  dismissedLater = output<void>();

  dismissedPermanently = output<void>();

  happyWithApp = output<void>();

  protected readonly currentStep = signal<1 | 2>(1);

  protected onHappyYes(): void {
    this.happyWithApp.emit();
  }

  protected onHappyNo(): void {
    this.currentStep.set(2);
  }

  protected onGiveFeedback(): void {
    this.openFeedbackForm.emit();
  }

  protected onMaybeLater(): void {
    this.dismissedLater.emit();
  }

  protected onNoThanks(): void {
    this.dismissedPermanently.emit();
  }

  protected onClose(): void {
    this.dismissedLater.emit();
  }
}
